import { fetchWithMasonryEndpoint } from './fetch-masonry-node';

export const PRIVACY_POLICY_API =
  'v1/masonry-node/consentManagement$authenticatedConsentManagement';

/**
 * Fetches the authenticated privacy policy and returns status code.
 * @returns {Promise<number>} status code of the response.
 */
export const getShowAuthPrivacyPolicy = async () => {
  const response = await fetchWithMasonryEndpoint(PRIVACY_POLICY_API);

  return response.status;
};
